import { isMacOS } from './browserUtilities';

const ENTER_KEY_CODE = 13;
const SPACE_KEY_CODE = 32;
const S_KEY_CODE = 83;
const LEFT_ARROW_KEY_CODE = 37;
const RIGHT_ARROW_KEY_CODE = 39;
const UP_ARROW_KEY_CODE = 38;
const DOWN_ARROW_KEY_CODE = 40;
const DELETE_KEY_CODE = 46;
const ESCAPE_KEY_CODE = 27;
const BACKSPACE_KEY_CODE = 8;
const Z_KEY_CODE = 90;
const Y_KEY_CODE = 89;

const isOperationKeyPressed = (event) => isMacOS() ? event.altKey : event.ctrlKey;

export function detectSaveKeyPress(event, callback) {
    if (isOperationKeyPressed(event) && event.keyCode === S_KEY_CODE) {
        event.preventDefault();
        callback();
    }
}

export function detectLocalPausePlayPreviewPress(event, callback) {
    if (isOperationKeyPressed(event) && event.keyCode === SPACE_KEY_CODE) {
        callback();
    }
}

export function detectGlobalPausePlayPreviewPress(event, callback) {
    if (event.keyCode === SPACE_KEY_CODE && !isOperationKeyPressed(event)) {
        callback();
    }
}

export function detectEscapePress(event, callback) {
    if (event.keyCode === ESCAPE_KEY_CODE) {
        callback();
    }
}

export function detectPreviewBackPress(event, callback) {
    if (isOperationKeyPressed(event) && event.keyCode === LEFT_ARROW_KEY_CODE) {
        callback();
    }
}

export function detectPreviewForwardPress(event, callback) {
    if (isOperationKeyPressed(event) && event.keyCode === RIGHT_ARROW_KEY_CODE) {
        callback();
    }
}

export function detectLyricsSegmentAddPress(event, callback) {
    if (isOperationKeyPressed(event) && event.keyCode === ENTER_KEY_CODE) {
        callback();
    }
}

export function detectLyricsSegmentDeletePress(event, callback) {
    if (isOperationKeyPressed(event) && (event.keyCode === BACKSPACE_KEY_CODE || event.keyCode === DELETE_KEY_CODE)) {
        callback();
    }
}

export function detectLyricsSegmentMoveUpPress(event, callback) {
    if (isOperationKeyPressed(event) && event.keyCode === UP_ARROW_KEY_CODE) {
        callback();
    }
}

export function detectLyricsSegmentMoveDownPress(event, callback) {
    if (isOperationKeyPressed(event) && event.keyCode === DOWN_ARROW_KEY_CODE) {
        callback();
    }
}

export function detectLyricsSegmentExpandPress(event, callback) {
    if (isOperationKeyPressed(event) && event.shiftKey && event.keyCode === DOWN_ARROW_KEY_CODE) {
        callback();
    }
}

export function detectLyricsSegmentShortenPress(event, callback) {
    if (isOperationKeyPressed(event) && event.shiftKey && event.keyCode === UP_ARROW_KEY_CODE) {
        callback();
    }
}

export function detectUndoPress(event, callback) {
    if (isOperationKeyPressed(event) && event.keyCode === Z_KEY_CODE) {
        callback();
    }
}

export function detectRedoPress(event, callback) {
    if (isOperationKeyPressed(event) && event.keyCode === Y_KEY_CODE) {
        callback();
    }
}